import { useState } from 'react'
import { Icon } from '@iconify/react'
import { patch } from '../../../../utils/Api'
import { useGlobalContext } from '../../../../utils/Context'
import Modal from '../../../../components/modal/Modal'
import FormLoader from '../../../../components/loader/FormLoader'

const PRESET_REASONS = [
  'ID document is blurry or unreadable',
  'Selfie does not match the photo on the ID',
  'Name on documents does not match the account',
  'Proof of address is older than 3 months',
  'Proof of address is unreadable or invalid',
  'ID document is expired',
  'Documents appear altered or fraudulent',
]

interface Props {
  submissionId: string
  customerName: string
  onClose: () => void
  onSuccess: () => void
}

const RejectKycModal = ({ submissionId, customerName, onClose, onSuccess }: Props) => {
  const { notify } = useGlobalContext()
  const [selected, setSelected] = useState('')
  const [customReason, setCustomReason] = useState('')
  const [loading, setLoading] = useState(false)

  const reason = selected === 'other' ? customReason.trim() : selected

  const reject = () => {
    if (!reason || reason.length < 5) {
      notify('error', 'Select or write a rejection reason')
      return
    }
    setLoading(true)
    patch(`kyc/admin/${submissionId}/reject`, { reason })
      .then((res: any) => {
        if (res.success) {
          notify('success', 'KYC rejected — customer has been notified with the reason')
          onClose()
          onSuccess()
        } else notify('error', res.message)
        setLoading(false)
      })
      .catch(() => setLoading(false))
  }

  return (
    <Modal position='center'>
      <div className='kyc-confirm-modal reject'>
        <div className='modal-header'>
          <div className='modal-icon icon-red'>
            <Icon icon='mdi:close-circle-outline' />
          </div>
          <h2>Reject Verification</h2>
          <p>
            <b>{customerName}</b> will be emailed this reason and given 3 days to
            resubmit.
          </p>
        </div>

        <div className='reason-list'>
          {PRESET_REASONS.map((preset) => (
            <label
              key={preset}
              className={`reason-option ${selected === preset ? 'selected' : ''}`}
            >
              <input
                type='radio'
                name='reason'
                checked={selected === preset}
                onChange={() => setSelected(preset)}
              />
              <span>{preset}</span>
            </label>
          ))}
          <label className={`reason-option ${selected === 'other' ? 'selected' : ''}`}>
            <input
              type='radio'
              name='reason'
              checked={selected === 'other'}
              onChange={() => setSelected('other')}
            />
            <span>Other reason…</span>
          </label>
          {selected === 'other' && (
            <textarea
              rows={3}
              placeholder='Explain what the customer needs to fix…'
              value={customReason}
              onChange={(e) => setCustomReason(e.target.value)}
              autoFocus
            />
          )}
        </div>

        {loading ? (
          <FormLoader position='center' />
        ) : (
          <div className='modal-actions'>
            <button className='btn-cancel' onClick={onClose}>
              Cancel
            </button>
            <button className='btn-danger' onClick={reject} disabled={!reason}>
              Reject &amp; Notify
            </button>
          </div>
        )}
      </div>
    </Modal>
  )
}

export default RejectKycModal
